var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRotate = function SvgArrowRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M14 3v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.793l-.914-.914A4.97 4.97 0 0 0 7.87 3.12h-.029A4.97 4.97 0 0 0 4.35 4.544a.5.5 0 0 1-.698-.715 6 6 0 0 1 8.437.05l.912.914V3a.5.5 0 0 1 1 0m-2.35 8.456a5 5 0 0 1-7.029-.042l-.914-.914H5.5a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-1.793l.914.914a5.96 5.96 0 0 0 4.211 1.758h.033a5.96 5.96 0 0 0 4.192-1.708.5.5 0 0 0-.699-.715"
  })));
};
export default SvgArrowRotate;